import type { Permission } from "../../../api/adminPermissions";

/** The group of the permissions declared by the core itself (no module). */
export const CORE_GROUP = "core";

/** The permission that opens the Admin Center; collaborators can never hold it. */
export const ADMIN_CENTER_PERMISSION = "core.admin";

export type PermissionGroup = [moduleId: string, permissions: Permission[]];

/** Permissions grouped by the module that declares them: the core first, then modules by id. */
export function groupPermissions(permissions: Permission[]): PermissionGroup[] {
  const map = new Map<string, Permission[]>();
  for (const p of permissions) {
    const key = p.moduleId ?? CORE_GROUP;
    map.set(key, [...(map.get(key) ?? []), p]);
  }
  return [...map.entries()].sort(([a], [b]) => (a === CORE_GROUP ? -1 : b === CORE_GROUP ? 1 : a.localeCompare(b)));
}

/** Adds or removes `keys` from the selection, without duplicates. */
export function toggleKeys(selected: string[], keys: string[], on: boolean): string[] {
  return on ? [...new Set([...selected, ...keys])] : selected.filter((k) => !keys.includes(k));
}
